export type ColorVariant =
  | 'black'
  | 'gray'
  | 'blue'
  | 'lightblue'
  | 'purple'
  | 'successful'
  | 'phaserbeam'
  | 'warn'
  | 'error'
  | 'yellow'
  | 'red';

export const labelColorVariants: Record<
  ColorVariant,
  {
    bgColor: string;
    textColor: string;
    borderColor: string;
  }
> = {
  black: {
    bgColor: 'bg-black-100 dark:bg-gray-800/40',
    textColor: 'text-black-700 dark:text-gray-300',
    borderColor: 'border-black-300 dark:border-gray-800',
  },
  gray: {
    bgColor: 'bg-gray-100 dark:bg-gray-700/40',
    textColor: 'text-gray-700 dark:text-gray-300/80',
    borderColor: 'border-gray-300 dark:border-gray-700',
  },
  blue: {
    bgColor: 'bg-blue-100 dark:bg-blue-900/40',
    textColor: 'text-blue-700 dark:text-blue-300/70',
    borderColor: 'border-blue-300 dark:border-blue-900',
  },
  lightblue: {
    bgColor: 'bg-sky-100 dark:bg-sky-900/40',
    textColor: 'text-sky-700 dark:text-sky-300/70',
    borderColor: 'border-sky-300 dark:border-sky-900',
  },
  purple: {
    bgColor: 'bg-purple-100 dark:bg-purple-700/40',
    textColor: 'text-purple-700 dark:text-purple-300/70',
    borderColor: 'border-purple-300 dark:border-purple-900',
  },
  successful: {
    bgColor: 'bg-successful-200 dark:bg-green-900/40',
    textColor: 'text-successful-700 dark:text-green-300/70',
    borderColor: 'border-successful-300 dark:border-green-900',
  },
  phaserbeam: {
    bgColor: 'bg-phaserbeam-100 dark:bg-phaserbeam-900/40',
    textColor: 'text-phaserbeam-700 dark:text-phaserbeam-200/90',
    borderColor: 'border-phaserbeam-300 dark:border-phaserbeam-900',
  },
  warn: {
    bgColor: 'bg-yellow-100 dark:bg-yellow-900/40',
    textColor: 'text-yellow-700 dark:text-yellow-200/70',
    borderColor: 'border-yellow-300 dark:border-yellow-900',
  },
  error: {
    bgColor: 'bg-error-200 dark:bg-red-900/40',
    textColor: 'text-error-700 dark:text-red-300/70',
    borderColor: 'border-error-300 dark:border-red-900',
  },
  yellow: {
    bgColor: 'bg-yellow-100 dark:bg-yellow-900/40',
    textColor: 'text-yellow-700 dark:text-yellow-200/70',
    borderColor: 'border-yellow-300 dark:border-yellow-900',
  },
  red: {
    bgColor: 'bg-red-100 dark:bg-red-900/40',
    textColor: 'text-red-700 dark:text-red-300/70',
    borderColor: 'border-red-300 dark:border-red-900',
  },
};
